import React, { useState } from "react";

const FILTERS = [
  "Powerlifting",
  "CrossFit",
  "Yoga",
  "Running",
  "HIIT",
  "Bodybuilding",
  "Calisthenics",
  "Olympic Lifting",
  "Boxing",
  "Pilates",
  "Spin",
  "Hiking",
];

const TrainingFilters = () => {
  const [active, setActive] = useState(["Powerlifting", "HIIT"]);

  const toggle = (f) =>
    setActive((curr) =>
      curr.includes(f) ? curr.filter((x) => x !== f) : [...curr, f]
    );

  return (
    <section
      id="filters"
      data-testid="training-filters-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
              Your Style. Your People.
            </p>
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
              Match Based
              <br />
              On How You
              <br />
              <span className="text-[#C6FF00]">Train.</span>
            </h2>
            <p className="mt-6 text-base text-neutral-400 max-w-md">
              Your lifestyle isn't generic. Your matches shouldn't be either.
              Pick the disciplines you live by — we'll handle the rest.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-[#111111] border border-white/5 rounded-2xl p-6 md:p-10">
              <div className="flex items-center justify-between mb-6">
                <span className="text-xs uppercase tracking-[0.25em] text-neutral-400 font-semibold">
                  Pick your training
                </span>
                <span
                  data-testid="filters-selected-count"
                  className="font-heading text-2xl text-[#C6FF00]"
                >
                  {String(active.length).padStart(2, "0")}
                </span>
              </div>

              <div className="flex flex-wrap gap-3">
                {FILTERS.map((f) => {
                  const isActive = active.includes(f);
                  return (
                    <button
                      key={f}
                      onClick={() => toggle(f)}
                      data-testid={`filter-pill-${f.toLowerCase().replace(/\s+/g, "-")}`}
                      className={`px-5 py-3 rounded-full text-sm font-semibold uppercase tracking-[0.15em] transition-all duration-300 border ${
                        isActive
                          ? "bg-[#C6FF00] text-[#0A0A0A] border-[#C6FF00] shadow-[0_0_20px_rgba(198,255,0,0.35)]"
                          : "bg-transparent text-neutral-200 border-white/15 hover:border-[#C6FF00] hover:text-[#C6FF00]"
                      }`}
                    >
                      {f}
                    </button>
                  );
                })}
              </div>

              <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between">
                <span className="text-xs text-neutral-500">
                  Tap to toggle. We use these to surface real partners.
                </span>
                <button
                  data-testid="filters-clear-btn"
                  onClick={() => setActive([])}
                  className="text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-[#C6FF00] font-semibold"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingFilters;
